module.exports = __webpack_public_path__ + "static/media/tz.4a49ea3b.svg";